import { TDevice } from '@cian/utils';

export enum ESiteType {
  desktop = 'desktop',
  mobile = 'mobile',
  tablet = 'tablet',
}

export const getSiteType = (deviceType: TDevice): ESiteType =>
  deviceType === 'phone' ? ESiteType.mobile : ESiteType[deviceType];
